import { yupResolver } from "@hookform/resolvers/yup";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { useFieldArray, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { FloatInput, FloatNumericInput, FloatSelect } from "src/componentes";
import {
  CTeCargaDto,
  CTeDto,
  getLocal,
  STORAGECTE_KEY,
  unidadeMedidaOptions,
  updateLocal,
} from "../CTe.Dto";
import { CargaFormType, CargaSchema } from "./CTe.Cadastro.Dto";

const CTeCadastroCargaView = () => {
  const navigate = useNavigate();
  const cte = getLocal<CTeDto>(STORAGECTE_KEY);
  const carga = cte?.carga;

  const form = useForm<CargaFormType>({
    resolver: yupResolver(CargaSchema),
    defaultValues: {
      valorCarga: carga?.valorCarga ?? 0,
      produtoPredominante: carga?.produtoPredominante ?? "",
      outraCaracteristica: carga?.outraCaracteristica ?? "",
      quantidades:
        carga?.quantidades && carga.quantidades.length > 0
          ? carga.quantidades
          : [
              {
                codigoUnidadeMedida: "02",
                tipoMedida: "PESO DECLARADO",
                quantidadeCarga: 0,
              },
            ],
    },
  });

  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: "quantidades",
  });

  const handleVoltar = () => {
    navigate("../destinatario");
  };

  const onSubmit = (data: CargaFormType) => {
    const cargaDto: CTeCargaDto = {
      valorCarga: Number(data.valorCarga),
      produtoPredominante: data.produtoPredominante,
      outraCaracteristica: data.outraCaracteristica || "",
      quantidades: (data.quantidades || []).map((q) => ({
        codigoUnidadeMedida: q.codigoUnidadeMedida,
        tipoMedida: q.tipoMedida,
        quantidadeCarga: Number(q.quantidadeCarga),
      })),
    };

    updateLocal<CTeDto>(STORAGECTE_KEY, {
      carga: cargaDto,
    });

    navigate("../valores");
  };

  return (
    <Form noValidate onSubmit={form.handleSubmit(onSubmit)} className="mt-3 mb-5">
      <h5 className="mb-3 text-primary">Informações da Carga</h5>
      <Row className="g-3">
        <Col xs={12} md={4}>
          <FloatNumericInput
            label="Valor Total da Carga"
            control={form.control}
            name="valorCarga"
            errorsMessage={form.formState.errors.valorCarga}
          />
        </Col>
        <Col xs={12} md={4}>
          <FloatInput
            label="Produto Predominante"
            registerField={form.register("produtoPredominante")}
            errorsMessage={form.formState.errors.produtoPredominante}
            inputMask="maiusculas"
          />
        </Col>
        <Col xs={12} md={4}>
          <FloatInput
            label="Outra Característica"
            registerField={form.register("outraCaracteristica")}
            errorsMessage={form.formState.errors.outraCaracteristica}
            inputMask="maiusculas"
          />
        </Col>
      </Row>

      <div className="d-flex justify-content-between align-items-center mt-4 mb-3">
        <h5 className="text-primary mb-0">Quantidades e Pesos da Carga</h5>
        <Button
          variant="outline-primary"
          size="sm"
          onClick={() =>
            append({
              codigoUnidadeMedida: "01",
              tipoMedida: "PESO BRUTO",
              quantidadeCarga: 0,
            })
          }
        >
          + Adicionar Quantidade
        </Button>
      </div>

      {fields.map((field, index) => (
        <div key={field.id} className="mb-4">
          <div className="d-flex justify-content-between align-items-center mb-2">
            <strong>Medida #{index + 1}</strong>
            {fields.length > 1 && (
              <Button
                variant="outline-danger"
                size="sm"
                onClick={() => remove(index)}
              >
                Remover
              </Button>
            )}
          </div>
          <Row className="g-3">
            <Col xs={12} md={4}>
              <FloatSelect
                label="Unidade de Medida"
                options={unidadeMedidaOptions}
                register={form.register(`quantidades.${index}.codigoUnidadeMedida`)}
                errorsMessage={
                  form.formState.errors.quantidades?.[index]?.codigoUnidadeMedida
                }
              />
            </Col>
            <Col xs={12} md={4}>
              <FloatInput
                label="Tipo de Medida"
                registerField={form.register(`quantidades.${index}.tipoMedida`)}
                errorsMessage={
                  form.formState.errors.quantidades?.[index]?.tipoMedida
                }
                inputMask="maiusculas"
              />
            </Col>
            <Col xs={12} md={4}>
              <FloatNumericInput
                label="Quantidade"
                control={form.control}
                name={`quantidades.${index}.quantidadeCarga`}
                errorsMessage={
                  form.formState.errors.quantidades?.[index]?.quantidadeCarga
                }
              />
            </Col>
          </Row>
        </div>
      ))}

      <div className="fixed-bottom">
        <Container className="py-3">
          <Row>
            <Col xs={6} className="d-grid">
              <Button variant="outline-secondary" onClick={handleVoltar}>
                Voltar
              </Button>
            </Col>
            <Col xs={6} className="d-grid">
              <Button variant="outline-primary" type="submit">
                Próximo
              </Button>
            </Col>
          </Row>
        </Container>
      </div>
    </Form>
  );
};

export default CTeCadastroCargaView;
